var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { iconPicker, isChevron } from "./helpers";
var IconComponent = function (props) {
    var extraLarge = props.extraLarge, large = props.large, small = props.small, size = props.size, icon = props.icon, block = props.block, rest = __rest(props
    // by default, Icons follow same dimensions as fonts in buttons
    , ["extraLarge", "large", "small", "size", "icon", "block"]);
    // by default, Icons follow same dimensions as fonts in buttons
    var iconSize = 16;
    var display = block ? "block" : "inline";
    if (large)
        iconSize = 18;
    if (extraLarge)
        iconSize = 20;
    if (small)
        iconSize = 14;
    // if the icon is a chevron, we want it to look smaller than the other icons
    if (isChevron(icon))
        iconSize -= 6;
    if (size)
        iconSize = size;
    var Icon = iconPicker(icon);
    return React.createElement(Icon, __assign({ display: display, size: iconSize }, rest));
};
export default styled(IconComponent)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export { default as IconTypes } from "./IconTypes.enum";
var templateObject_1;
